module.exports = __webpack_public_path__ + "static/Red_Darkmode-4222ad51bf97131986335f9ca35227dd.mp4";